'use client';

import { motion } from 'framer-motion';

import { cn } from '@/lib/utils';

interface Props {
  className?: string;
}

export default function Logo({ className }: Props) {
  return (
    <motion.div
      whileHover={{ rotate: 360 }}
      transition={{ type: 'spring', stiffness: 100, damping: 10 }}
      className={cn('h-6 w-6', className)}
    >
      <motion.svg
        viewBox='0 0 585 584'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        className='h-full w-full'
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        {[
          'M583.915 415.637C583.232 437.276 578.709 466.344 563.387 492.299C549.111 516.478 531.137 537.405 507.621 553.889C477.305 575.138 443.651 583.9 407.633 583.853C369.747 583.802 334.733 574.101 303.785 550.313C266.835 521.912 242.843 485.765 234.592 440.181C228.835 408.368 231.221 376.525 242.556 345.803C246.06 336.307 247.465 336.009 255.197 342.352C268.207 353.024 280.249 365.144 295.449 372.729C323.084 386.519 351.583 397.471 382.801 400.839C414.892 404.3 446.064 401.131 476.632 391.519C508.611 381.463 537.099 365.177 561.756 342.289C569.252 335.332 570.233 335.627 573.357 345.368C579.832 365.563 583.932 386.204 583.915 415.637Z',
          'M177.245 231.911C200.009 231.532 221.532 236.273 242.299 245.228C247.549 247.492 247.215 248.891 243.683 252.709C222.185 275.951 204.113 301.705 194.337 331.939C184.471 362.451 179.419 393.831 182.977 426.349C185.287 447.455 188.512 468.354 195.815 488.123C203.017 507.619 212.645 526.187 226.683 542.051C233.281 549.507 237.473 558.821 245.071 565.624C249.54 569.625 244.552 570.44 242.109 571.835C228.531 579.588 213.18 580.078 198.297 582.128C168.713 586.201 139.452 583.583 111.696 572.781C93.451 565.681 76.638 555.521 61.6958 542.083C50.5729 532.08 40.2417 521.705 31.6693 509.544C15.4484 486.532 5.98747 460.72 1.92027 433.111C-3.18754 398.439 2.31507 365.587 16.774 333.156C26.9182 310.401 41.976 292.712 59.5661 276.421C92.7292 245.707 132.876 233.024 177.245 231.911Z',
          'M0.0556946 180.724C-0.672431 150.077 5.80934 126.905 15.3625 104.355C24.6396 82.4547 38.9073 64.684 55.864 47.876C89.2729 14.76 130.365 2.41069 175.224 0.124027C195.041 -0.88664 214.551 4.5227 233.967 10.0934C264.169 18.76 287.583 37.232 307.915 59.1214C327.023 79.692 339.456 105.147 346.647 132.649C356.412 169.993 354.48 206.56 339.544 242.401C336.963 248.597 335.275 248.095 331.083 244.023C296.832 210.751 255.383 191.695 208.696 184.016C172.584 178.076 137.176 181.799 102.66 194.444C77.2896 203.737 53.7062 216.107 32.4114 232.72C28.1584 236.039 23.7942 239.585 20.6708 243.891C16.2245 250.019 15.2193 246.845 13.3458 242.343C4.34893 220.721 -0.504201 198.317 0.0556946 180.724Z',
          'M336.497 336.649C353.199 319.257 366.401 300.031 377.439 279.389C397.715 241.467 405.535 201.211 402.275 158.085C399.603 122.728 388.224 90.7494 370.391 60.8881C361.972 46.7921 353.463 32.3787 341.18 20.9694C337.293 17.3587 337.575 15.4294 342.62 13.3947C379.637 -1.52662 417.063 -3.24393 455.751 7.04673C507.652 20.8534 544.081 53.5281 567.124 100.139C585.115 136.531 588.229 176.228 579.508 216.351C567.724 270.556 535.168 309.716 487.012 334.075C454.815 350.361 419.064 357.013 382.089 350.179C366.555 347.307 351.651 343.023 336.497 336.649Z',
        ].map((d, index) => (
          <motion.path
            key={index}
            d={d}
            fill='currentColor'
            initial={{ pathLength: 0 }}
            animate={{ pathLength: 1 }}
            transition={{ duration: 2 + index * 0.5 }}
            stroke='currentColor'
            strokeWidth={2}
          />
        ))}
      </motion.svg>
    </motion.div>
  );
}
